{
  "satis_hedef_group": {
    "Baslik": "Verkoopdoelgroep Definities",
    "Ad": "Groepsnaam",
    "Birim": "Valuta (TL/USD)",
    "UrunAta": "Product Toewijzen",
    "UrunModeli Seç": "Selecteer Product",
    "Urun Seç": "Selecteer Product",
    "UrunAd": "Productnaam",
    "FirmaAd": "Bedrijfsnaam",
    "Products": "Toegewezen Producten",
    "Ara": "Zoeken...",
    "Hepsi": "Alle",
    "Aktif": "Actief",
    "Pasif": "Passief",
    "Durum": "Status",
    "Duzenle": "Bewerken",
    "Yeni Ekle": "Toevoegen",
    "Filtrele": "Filteren",
    "Temizle": "Wissen",
    "Data Yenile": "Gegevens Vernieuwen",
    "ARA": "ZOEKEN",
    "Kapat": "Sluiten",
    "Yenile": "Vernieuwen",
    "Dolar": "USD",
    "TL": "TL",
    "Ekle": "Toevoegen",
    "Guncelle": "Bijwerken",
    "Kaydet": "Opslaan",
    "Iptal": "Annuleren",
    "Islem": "Actie",
    "Urun yok": "Geen producten toegewezen"
  }
}
